import React from 'react';
import Wrapper from '../../Components/Wrapper/wrapper';
import { ParentsList } from '../../Components/parents/parentsList';

export const ParentsListPage = () => {
  return (
    <Wrapper header={'Parents'}>
      <ParentsList />
    </Wrapper>
  );
};
